import CompletedStep from './CompletedStep';

export default CompletedStep;
